import { useAuthStore } from '@/Stores/Auth'

export function RequireChemicalExlorer() {
    if (! useAuthStore().hasModule('chemical_explorer')) {
        return { name: 'NotFound' }
    }
    return true
}
